var map = {
	"./computer/TradeDetail/TradeDetail.vue": [
		"68bf",
		"chunk-efef632e"
	],
	"./mobile/TradeDetail/TradeDetail.vue": [
		"6b6f",
		"chunk-7bfb2e4e"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "28f3";
module.exports = webpackAsyncContext;